import { TeamTile } from "../../../../components/analysis/tiles";
import {
  Grid,
  Box,
  TablePagination,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";

export default function TeamsPage({ event, teams }) {
  const [teamList, setTeamList] = useState(teams);

  const [teamLowerBound, setTeamLowerBound] = useState(0);
  const [teamsShown, setTeamsShown] = useState(12);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    setTeamLowerBound(newPage * teamsShown);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(Math.floor(page * (teamsShown / parseInt(event.target.value, 10))));
    setTeamsShown(parseInt(event.target.value, 10));
    setTeamLowerBound(
      Math.floor(page * (teamsShown / parseInt(event.target.value, 10))) *
        parseInt(event.target.value, 10)
    );
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    setPage(0);
    setTeamLowerBound(0);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6}>
        <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
          <TextField
            name="searchTeam"
            label="Search"
            sx={{ width: "75%" }}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </Box>
      </Grid>

      <Grid item xs={12} lg={6}>
        <Box sx={{ display: "flex", justifyContent: "right" }}>
          <TablePagination
            count={
              teamList.filter(
                (team) =>
                  (team.team_number.toString().includes(search) ||
                    team.nickname
                      .toLowerCase()
                      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
                      .includes(
                        search
                          .toLowerCase()
                          .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
                      )) &&
                  !team.nickname.includes("Off-Season Demo Team")
              ).length
            }
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={teamsShown}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[12, 24, 48]}
          />
        </Box>
      </Grid>
      {teamList
        .filter(
          (team) =>
            (team.team_number.toString().includes(search) ||
              team.nickname
                .toLowerCase()
                .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
                .includes(
                  search
                    .toLowerCase()
                    .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
                )) &&
            !team.nickname.includes("Off-Season Demo Team")
        )
        .slice(teamLowerBound, teamLowerBound + teamsShown)
        .map((team) => (
          <TeamTile key={team.team_number} team={team} event={event} />
        ))}
    </Grid>
  );
}
